export default __webpack_public_path__ + "static/media/maths.17586ad8.png";